export const SORT_ORDER = Object.freeze({
    ASCENDING_ORDER: 'A to Z',
    DESCENDING_ORDER: 'Z to A',
    NEWEST_FIRST: 'Newest First',
    OLDEST_FIRST: 'Oldest First',
});

export const skillsFilterDropdown = Object.freeze([
    {
        value: SORT_ORDER.ASCENDING_ORDER,
        label: 'Skill Title: A to Z',
    },

    {
        value: SORT_ORDER.DESCENDING_ORDER,
        label: 'Skill Title: Z to A',
    },
    {
        value: SORT_ORDER.NEWEST_FIRST,
        label: 'Date Updated: Newest First',
    },
    {
        value: SORT_ORDER.OLDEST_FIRST,
        label: 'Date Updated: Oldest First',
    },
]);

export const favoriteContentFilterDropdown = Object.freeze([
    {
        value: SORT_ORDER.ASCENDING_ORDER,
        label: 'Title: A to Z',
    },
    {
        value: SORT_ORDER.DESCENDING_ORDER,
        label: 'Title: Z to A',
    },
    {
        value: SORT_ORDER.NEWEST_FIRST,
        label: 'Date favorited: Newest First',
    },
    {
        value: SORT_ORDER.OLDEST_FIRST,
        label: 'Date favorited: Oldest First',
    },
]);

export const relevanceFilterDropdown = Object.freeze([
    {
        value: 'relevance',
        label: 'Relevance',
    },
    {
        value: 'normalizeditemtitle asc',
        label: 'Title: A to Z',
    },
    {
        value: 'normalizeditemtitle desc',
        label: 'Title: Z to A',
    },
    {
        value: 'pubdate',
        label: 'Recently updated',
    },
]);
